// extracted by mini-css-extract-plugin
module.exports = {"review_form":"_3ea6fa5da8--review_form--eTqYJ","description":"_3ea6fa5da8--description--KDQ1j","container":"_3ea6fa5da8--container--ku_dy"};